export const WIZARD_CAMPAIGN_GOALS = [
  { value: 'lead_generation', label: 'Lead Generation' },
  { value: 'appointment_booking', label: 'Appointment Booking' },
  { value: 'product_enquiry', label: 'Product Enquiry' },
  { value: 'service_request', label: 'Service Request' },
];

export const GOAL_LABEL_BY_VALUE = Object.fromEntries(
  WIZARD_CAMPAIGN_GOALS.map((g) => [g.value, g.label])
);
